
// // src/components/Service.js
// import React from "react";

// const vehicles = [
//   {
//     id: 2,
//     name: "Hyundai Aura",
//     price: 1800,
//     duration: "Day",
//     seats: 4,
//     bags: 2,
//     suv: 0,
//     fuel: ["Petrol", "CNG"],
//     image: "/images/fleet/aura.jpg",
//   },
//   {
//     id: 3,
//     name: "Maruti Dzire",
//     price: 2000,
//     duration: "Day",
//     seats: 4,
//     bags: 2,
//     suv: 0,
//     fuel: ["Petrol", "CNG"],
//     image: "/images/fleet/dsire.jpg",
//   },
//   {
//     id: 4,
//     name: "Maruti Ertiga",
//     price: 2600,
//     duration: "Day",
//     seats: 7,
//     bags: 4,
//     suv: 0,
//     fuel: ["Petrol", "CNG"],
//     image: "/images/fleet/ertiga.jpg",
//   },
//   {
//     id: 5,
//     name: "Kia Carens",
//     price: 2500,
//     duration: "Day",
//     seats: 6,
//     bags: 3,
//     suv: 0,
//     fuel: ["Petrol", "Diesel"],
//     image: "/images/fleet/kia.jpg",
//   },
//   {
//     id: 6,
//     name: "Toyota Innova Crysta",
//     price: 3500,
//     duration: "Day",
//     seats: 7,
//     bags: 4,
//     suv: 0,
//     fuel: ["Diesel"],
//     image: "/images/fleet/innova-crysta.jpg",
//   },
//   {
//     id: 11,
//     name: "Toyota Innova",
//     price: 3000,
//     duration: "Day",
//     seats: 7,
//     bags: 4,
//     suv: 0,
//     fuel: ["Diesel", "Petrol"],
//     image: "/images/fleet/innova.jpeg",
//   },
//   {
//     id: 7,
//     name: "Toyota Fortuner",
//     price: 6000,
//     duration: "Day",
//     seats: 7,
//     bags: 5,
//     suv: 1,
//     fuel: ["Diesel"],
//     image: "/images/fleet/fortuner.jpg",
//   },
//   {
//     id: 8,
//     name: "Tempo Traveller",
//     price: 4000,
//     duration: "Day",
//     seats: 12,
//     bags: 8,
//     suv: 0,
//     fuel: ["Diesel"],
//     image: "/images/fleet/tempo-traveller.jpg",
//   },
//   {
//     id: 9,
//     name: "Force Urbania",
//     price: 5500,
//     duration: "Day",
//     seats: 17,
//     bags: 10,
//     suv: 0,
//     fuel: ["Diesel"],
//     image: "/images/fleet/urbania.jpg",
//   },
//   {
//     id: 10,
//     name: "Luxury Bus",
//     price: 9000,
//     duration: "Day",
//     seats: 40,
//     bags: 20,
//     suv: 0,
//     fuel: ["Diesel"],
//     image: "/images/fleet/bus.jpg",
//   }
// ];

// const Ourfleets = () => {
//   return (
//     <>
//       {/* Breadcrumb */}
//       <div className="breadcrumb-bar">
//         <div className="container">
//           <div className="row align-items-center text-center">
//             <div className="col-md-12">
//               <h2 className="breadcrumb-title">Our Fleets</h2>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Fleet Section */}
//       <div className="section-full py-5 site-bg-white twm-cars-section-wrap">
//         <div className="container">
//           <div className="row">

//             {vehicles.map((vehicle) => (
//               <div
//                 key={vehicle.id}
//                 className="col-lg-4 col-md-6 mb-4"
//               >
//                 <div className="twm-vehicle-fleet-bx twm-custom-grid-3 borderr">

//                   {/* Vehicle Image */}
//                   <div className="twm-vehicle-fleet-media borderr">
//                     <img
//                       src={vehicle.image}
//                       alt={vehicle.name}
//                       className="img-fluid"
//                       loading="lazy"
//                     />
//                   </div>

//                   {/* Vehicle Content */}
//                   <div className="twm-vehicle-fleet-content">

//                     <h3 className="twm-v-title twmtitle text-center">
//                       {vehicle.name}
//                     </h3>

//                     <ul className="twm-vehicle-facility">

//                       <li>
//                         <span>
//                           <img src="/images/icons/car-seat.png" alt="" />
//                         </span>
//                         {vehicle.seats} Seats
//                       </li>

//                       <li>
//                         <span>
//                           <img src="/images/icons/bag.png" alt="" />
//                         </span>
//                         {vehicle.bags} Bags
//                       </li>

//                       <li>
//                         <span>
//                           <img src="/images/icons/car.png" alt="" />
//                         </span>
//                         {vehicle.suv ? "SUV" : "Standard"}
//                       </li>

//                     </ul>

//                     {/* <div className="twm-vehicle-price">
//                       ₹{vehicle.price} / {vehicle.duration}
//                     </div> */}

//                   </div>

//                 </div>
//               </div>
//             ))}

//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Ourfleets;





import React from "react";

const vehicles = [
  {
    id: 2,
    name: "Hyundai Aura",
    price: 1800,
    duration: "Day",
    seats: 4,
    bags: 2,
    suv: 0,
    type: "Sedan",
    fuel: ["Petrol", "CNG"],
    ac: true,
    transmission: "Manual",
    tag: "Budget",
    image: "/images/fleet/aura.jpg",
  },
  {
    id: 3,
    name: "Maruti Dzire",
    price: 2000,
    duration: "Day",
    seats: 4,
    bags: 2,
    suv: 0,
    type: "Sedan",
    fuel: ["Petrol", "CNG"],
    ac: true,
    transmission: "Manual",
    tag: "Most Popular",
    image: "/images/fleet/dsire.jpg",
  },
  {
    id: 4,
    name: "Maruti Ertiga",
    price: 2600,
    duration: "Day",
    seats: 7,
    bags: 4,
    suv: 0,
    type: "MPV",
    fuel: ["Petrol", "CNG"],
    ac: true,
    transmission: "Manual",
    tag: "Family",
    image: "/images/fleet/ertiga.jpg",
  },
  {
    id: 5,
    name: "Kia Carens",
    price: 2500,
    duration: "Day",
    seats: 6,
    bags: 3,
    suv: 0,
    type: "MPV",
    fuel: ["Petrol", "Diesel"],
    ac: true,
    transmission: "Manual",
    tag: "Premium",
    image: "/images/fleet/kia.jpg",
  },
  {
    id: 6,
    name: "Toyota Innova Crysta",
    price: 3500,
    duration: "Day",
    seats: 7,
    bags: 4,
    suv: 1,
    type: "SUV",
    fuel: ["Diesel"],
    ac: true,
    transmission: "Automatic",
    tag: "Top Rated",
    image: "/images/fleet/innova-crysta.jpg",
  },
  {
    id: 11,
    name: "Toyota Innova",
    price: 3000,
    duration: "Day",
    seats: 7,
    bags: 4,
    suv: 1,
    type: "SUV",
    fuel: ["Diesel", "Petrol"],
    ac: true,
    transmission: "Manual",
    tag: "Comfort",
    image: "/images/fleet/innova.jpeg",
  },
  {
    id: 7,
    name: "Toyota Fortuner",
    price: 6000,
    duration: "Day",
    seats: 7,
    bags: 5,
    suv: 1,
    type: "Luxury SUV",
    fuel: ["Diesel"],
    ac: true,
    transmission: "Automatic",
    tag: "Luxury",
    image: "/images/fleet/fortuner.jpg",
  },
  {
    id: 8,
    name: "Tempo Traveller",
    price: 4000,
    duration: "Day",
    seats: 12,
    bags: 8,
    suv: 0,
    type: "Traveller",
    fuel: ["Diesel"],
    ac: true,
    transmission: "Manual",
    tag: "Group Travel",
    image: "/images/fleet/tempo-traveller.jpg",
  },
  {
    id: 9,
    name: "Force Urbania",
    price: 5500,
    duration: "Day",
    seats: 17,
    bags: 10,
    suv: 0,
    type: "Luxury Van",
    fuel: ["Diesel"],
    ac: true,
    transmission: "Manual",
    tag: "Premium Group",
    image: "/images/fleet/urbania.jpg",
  },
  {
    id: 10,
    name: "Luxury Bus",
    price: 9000,
    duration: "Day",
    seats: 40,
    bags: 20,
    suv: 0,
    type: "Bus",
    fuel: ["Diesel"],
    ac: true,
    transmission: "Manual",
    tag: "Corporate",
    image: "/images/fleet/bus.jpg",
  }
];

const Ourfleets = () => {
  return (
    <>
      <div className="breadcrumb-bar text-center">
        <h2 className="breadcrumb-title">Our Fleets</h2>
      </div>

      <div className="container py-5">
        <div className="row">

          {vehicles.map((vehicle) => (
            <div key={vehicle.id} className="col-lg-4 col-md-6 mb-4">

              <div className="fleet-card">

                {/* IMAGE */}
                <div className="fleet-img">
                  <img src={vehicle.image} alt={vehicle.name} />
                  {/* <span className="price-badge">
                    ₹{vehicle.price} / {vehicle.duration}
                  </span> */}
                </div>

                {/* CONTENT */}
                <div className="fleet-content bggg">

                  <h4 className="darkcolorrr">{vehicle.name}</h4>

                  {/* SPEC GRID */}
                  <div className="spec-grid bggg">
                    <div>👥 {vehicle.seats} Seats</div>
                    <div>🧳 {vehicle.bags} Bags</div>
                    <div>🚘 {vehicle.suv ? "SUV" : "Standard"}</div>
                    <div>⛽ {vehicle.fuel.join(", ")}</div>
                    <div>❄ AC: {vehicle.ac ? "Yes" : "No"}</div>
                    <div>⚙ {vehicle.transmission}</div>
                  </div>

                  {/* BUTTON */}
                  {/* <button className="book-btn">Book Now</button> */}

                </div>

              </div>

            </div>
          ))}

        </div>
      </div>
    </>
  );
};

export default Ourfleets;